import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Paper,
  Typography,
  type PaperProps,
} from '@mui/material';

import { useMemo } from 'react';
import { Button } from '~/components/Button';
import { useUser } from '~/hooks/useUser';

interface BlurredUpgradeModalProps extends PaperProps {
  offsetTop: number;
  title: string;
  description: string;
  reason: 'search.blurred' | 'domains.blurred';
}

export default function BlurredUpgradeModal({
  offsetTop,
  title,
  description,
  reason,
  ...paperProps
}: BlurredUpgradeModalProps) {
  const user = useUser();
  const href = useMemo(() => {
    return user.isGuest
      ? `/signup?reason=${reason}`
      : `/pricing?reason=${reason}`;
  }, [user.isGuest, reason]);
  const { sx, ...restPaperProps } = paperProps;
  return (
    <Paper
      sx={{
        position: 'absolute',
        top: `${offsetTop + 40}px`,
        marginLeft: '20%',
        marginRight: 'auto',
        width: '60%',
        ...sx,
      }}
      {...restPaperProps}>
      <Card>
        <CardHeader title={title} />
        <CardContent>
          <Typography>{description}</Typography>
        </CardContent>
        <CardActions>
          <Button variant="contained" href={href}>
            {user.isGuest ? 'Sign Up For Free' : 'View Pricing'}
          </Button>
        </CardActions>
      </Card>
    </Paper>
  );
}
